import { render, staticRenderFns } from "./QuienesSomos.vue?vue&type=template&id=7ba87452&scoped=true"
import script from "./QuienesSomos.vue?vue&type=script&lang=ts"
export * from "./QuienesSomos.vue?vue&type=script&lang=ts"
import style0 from "./QuienesSomos.vue?vue&type=style&index=0&id=7ba87452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba87452",
  null
  
)

export default component.exports